<img *ngIf="src" [src]="src" [alt]="alt" />
